<template>
  <div>
    <router-link style="margin-right: 25px" :to="{
      name: 'wa_manager',
    }" :title="'Сообщения whatsapp'">
      <v-badge :content="$root.whatsappUnVeiwed" :value="$root.whatsappUnVeiwed" color="green" overlap>
        <v-icon large> mdi-whatsapp </v-icon>
      </v-badge>
    </router-link>
    <v-snackbar v-model="showMessage" :timeout="8000">
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="showMessage = false">
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
  
<script>
export default {
  data() {
    return {
      showMessage: false,
      text: ""
    }
  },
  created() {
    this.fetchData();
    this.$root.$on("websocket", this.registerWS);
    this.$root.$on("update_income_wa", this.registerUpdateIncomeWA);
  },
  destoyed() {
    this.$root.$off("websocket", this.registerWS);
    this.$root.$off("update_income_wa", this.registerUpdateIncomeWA);
  },
  methods: {
    registerUpdateIncomeWA() {
      this.fetchData();
    },
    registerWS(data) {
      if (data && data.e == "whatsapp") {
        const r = data.r;
        if (r.type == 2) {
          this.$root.whatsappUnVeiwed++;
          this.showMessage = true;
          this.text = r.message;
          this.$root.$emit('new_income_wa', r);
        }
      }
    },
    async fetchData() {
      try {
        const response = await this.$axios.g(this.$root.api.baseUrl + "/whatsapp/message/manager_unviewed");
        if (response.data.data && response.data.data.wa_unviewed) this.$root.whatsappUnVeiwed = response.data.data.wa_unviewed;
        else this.$root.whatsappUnVeiwed = 0;
      } catch (error) {
        console.error(error);
      }
    },
  }
};
</script>